import React, { useState } from 'react';
import { insertMaintenance } from '../../services/api/diary-ui';
import { useAuth } from '../USER/Auth/AuthContext';
import { Settings2, Map, DollarSign, Calendar, Wrench, Check, X } from 'lucide-react';
import Swal from 'sweetalert2';
import { BryButton, BryCard } from '../UI/BryUI';
import Cleave from 'cleave.js/react';

const RegisterMaintenance = ({ onClose }) => {
  const { currentUser } = useAuth();
  const [form, setForm] = useState({
    data: new Date().toISOString().split('T')[0],
    peca: '',
    km: '',
    kmProximaTroca: '',
    valor: '',
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleCleaveChange = (name, value) => {
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!currentUser) { 
        Swal.fire('Error', 'Usuario no autenticado.', 'error');
        return; 
    }
    setLoading(true);

    const { error: err } = await insertMaintenance({
      user_id: currentUser.id,
      data: form.data,
      peca: form.peca,
      km: Number(form.km),
      kmProximaTroca: Number(form.kmProximaTroca),
      valor: Number(form.valor),
    });

    if (err) {
      Swal.fire('Error', err.message, 'error');
    } else {
      Swal.fire({
        title: '¡Registrado!',
        text: 'Mantenimiento guardado correctamente.',
        icon: 'success',
        confirmButtonColor: 'var(--bry-accent)'
      }).then(() => onClose && onClose());
      
      setForm({ data: new Date().toISOString().split('T')[0], peca: '', km: '', kmProximaTroca: '', valor: '' });
    }
    setLoading(false);
  };

  return (
    <div className="flex flex-col gap-4 animate-in fade-in duration-200">
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <BryCard className="p-4 bg-gray-900 border-gray-800 flex flex-col gap-4">
          
          <div className="flex flex-col">
            <label className="text-xs font-semibold text-gray-400 mb-1 block">Fecha</label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Calendar size={16} className="text-[var(--bry-accent)]" />
              </div>
              <input 
                type="date" 
                name="data" 
                className="w-full pl-10 bg-gray-800 border border-gray-700 text-white text-sm rounded-lg focus:ring-[var(--bry-accent)] focus:border-[var(--bry-accent)] block p-2.5 outline-none transition-colors"
                value={form.data} 
                onChange={handleChange} 
                required 
              />
            </div>
          </div>

          <div className="flex flex-col">
            <label className="text-xs font-semibold text-gray-400 mb-1 block">Pieza / Servicio</label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Wrench size={16} className="text-[var(--bry-accent)]" />
              </div>
              <input 
                type="text" 
                name="peca" 
                className="w-full pl-10 bg-gray-800 border border-gray-700 text-white text-sm rounded-lg focus:ring-[var(--bry-accent)] focus:border-[var(--bry-accent)] block p-2.5 outline-none transition-colors"
                value={form.peca} 
                onChange={handleChange} 
                placeholder="Ej: Cambio de aceite" 
                required 
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3">
              <div className="flex flex-col">
                <label className="text-xs font-semibold text-gray-400 mb-1 block">KM actual</label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <Map size={16} className="text-[var(--bry-accent)]" />
                  </div>
                  <Cleave
                    options={{ numeral: true, numeralThousandsGroupStyle: 'none' }}
                    placeholder="Ej: 12500"
                    value={form.km}
                    onChange={(e) => handleCleaveChange('km', e.target.rawValue)}
                    className="w-full pl-10 bg-gray-800 border border-gray-700 text-white text-sm rounded-lg focus:ring-[var(--bry-accent)] focus:border-[var(--bry-accent)] block p-2.5 outline-none transition-colors"
                  />
                </div>
              </div>

              <div className="flex flex-col">
                <label className="text-xs font-semibold text-gray-400 mb-1 block">KM próxima revisión</label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <Settings2 size={16} className="text-[var(--bry-accent)]" />
                  </div>
                  <Cleave
                    options={{ numeral: true, numeralThousandsGroupStyle: 'none' }}
                    placeholder="Ej: 15500"
                    value={form.kmProximaTroca}
                    onChange={(e) => handleCleaveChange('kmProximaTroca', e.target.rawValue)}
                    className="w-full pl-10 bg-gray-800 border border-gray-700 text-white text-sm rounded-lg focus:ring-[var(--bry-accent)] focus:border-[var(--bry-accent)] block p-2.5 outline-none transition-colors"
                  />
                </div>
              </div>
          </div>

          <div className="flex flex-col">
            <label className="text-xs font-semibold text-gray-400 mb-1 block">Costo ($)</label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <DollarSign size={16} className="text-[var(--bry-accent)]" />
              </div>
              <Cleave
                options={{ numeral: true, numeralDecimalScale: 2 }}
                placeholder="0.00"
                value={form.valor}
                onChange={(e) => handleCleaveChange('valor', e.target.rawValue)}
                className="w-full pl-10 bg-gray-800 border border-gray-700 text-white text-sm rounded-lg focus:ring-[var(--bry-accent)] focus:border-[var(--bry-accent)] block p-2.5 outline-none transition-colors"
              />
            </div>
          </div>

        </BryCard>

        <div className="flex gap-3 mt-2">
          {onClose && (
            <BryButton type="button" variant="secondary" className="w-1/2 justify-center" onClick={onClose}>
              <X size={18} className="mr-2" /> Cancelar
            </BryButton>
          )}
          <BryButton type="submit" variant="primary" className={onClose ? "w-1/2 justify-center" : "w-full justify-center"} disabled={loading}>
            {loading ? '...' : <><Check size={18} className="mr-2" /> Guardar</>}
          </BryButton>
        </div>
      </form>
    </div>
  );
};

export default RegisterMaintenance;
